import { OffersBundleApiClient } from '@fourthwall/services/dist/OffersBundleApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useOfferBundleCreationMutation = createMutationHook(
  OffersBundleApiClient.createOfferBundle,
  {
    mutationKey: ['offerBundleCreation'],
  },
)
